/* eslint-disable linebreak-style */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

/**
 * Check is localhost version
 * @type {boolean}
 */
const isLocalhost = typeof window !== 'undefined' ? Boolean(
  window.location.hostname === 'localhost'
  // [::1] is the IPv6 localhost address.
  || window.location.hostname === '[::1]'
  // 127.0.0.0/8 are considered localhost for IPv4.
  || window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
  ),
) : true;

/**
 * Check is the Facebook Browser
 * @returns {boolean}
 */
const isFacebookBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return ua.indexOf('FB') !== -1;
  // return (ua.indexOf('FBAN') !== -1) || (ua.indexOf('FBAV') !== -1);
};

/**
 * Check is a debug request
 * @returns {boolean}
 */
const enableDebug = () => {
  const query = window.location.search;
  return query.includes('sw_debug=true');
};

export function register(config) {
  // Validate with is a production env, has a serviceWroker and ignore FacebookBrowser
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator
    && !isFacebookBrowser()) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    const swUrl = `/sw.js${enableDebug() ? '?debug' : ''}`;
    if (isLocalhost) {
      // This is running on localhost. Let's check if a service worker still exists or not.
      checkValidServiceWorker(swUrl, config);

      // Add some additional logging to localhost, pointing developers to the
      // service worker/PWA documentation.
      navigator.serviceWorker.ready.then((registration) => {
        periodicSyncRegister(registration);
        if (enableDebug()) {
          console.log(
            'This web app is being served cache-first by a service '
            + 'worker. To learn more, visit https://bit.ly/CRA-PWA',
          );
        }
      });
    } else {
      // Is not localhost. Just register service worker
      registerValidSW(swUrl, config);
      navigator.serviceWorker.ready.then((registration) => {
        periodicSyncRegister(registration);
      });
    }
  }
}

async function periodicSyncRegister(registration) {
  try {
    const status = await navigator.permissions.query({
      name: 'periodic-background-sync',
    });
    if (status.state === 'granted') {
      await registration.periodicSync.register('fetch-latest-posts', {
        minInterval: 60 * 1000, // 24 * 60 * 60 * 1000, // An interval of one day.
      });

      if ('periodicSync' in registration) {
        const tags = await registration.periodicSync.getTags();
        // Only update content if sync isn't set up.
        if (!tags.includes('fetch-latest-posts')) {
          window.location.reload();
        }
      } else {
        // If periodic background sync isn't supported, always update.
        window.location.reload();
      }
    } else if (enableDebug()) {
      console.log('Periodic background sync cannot be used.');
    }
  } catch {
    if (enableDebug()) {
      console.log('Periodic Sync could not be registered!');
    }
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              if (enableDebug()) {
                console.log(
                  'New content is available and will be used when all '
                  + 'tabs for this page are closed. See https://bit.ly/CRA-PWA.',
                );
              }

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              if (enableDebug()) {
                console.log('Content is cached for offline use.');
              }

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });

  navigator.serviceWorker.addEventListener('change', () => {
    window.location.reload();
  });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404
        || (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(async (registration) => {
          await registration.unregister();
          if ('periodicSync' in registration) {
            await registration.periodicSync.unregister('content-sync');
          }
          window.location.reload();
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      if (enableDebug()) {
        console.log(
          'No internet connection found. App is running in offline mode.',
        );
      }
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(async (registration) => {
        await registration.unregister();
        if ('periodicSync' in registration) {
          await registration.periodicSync.unregister('content-sync');
        }
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
